export default (initialValue = 0, type = 'money') => ({
    value: initialValue,
    type: type,
    currentVal: 0,
    steps: [],
    offset: 0,
    duration: 0,
    itemHeight: 32,
    isSpinning: true,
    animationTimeout: null,

    init() {
        this.steps = [this.format(0)];

        this.$nextTick(() => {
            this.spinTo(this.decimalValue);
        });

        this.$watch('value', (newValue, oldValue) => {
            if (newValue !== oldValue) {
                this.spinTo(this.decimalValue);
            }
        });
    },

    reSpin() {
        this.spinTo(this.decimalValue);
    },

    spinTo(targetValue) {
        this.isSpinning = true;

        if (this.animationTimeout) {
            clearTimeout(this.animationTimeout);
            this.animationTimeout = null;
        }

        const startValue = this.currentVal;
        const stepCount = 20;
        const diff = targetValue - startValue;
        const increment = diff / stepCount;

        let newSteps = [];
        for (let i = 0; i <= stepCount; i++) {
            let val = startValue + (increment * i);
            newSteps.push(this.format(val));
        }

        newSteps[stepCount] = this.format(targetValue);

        this.steps = newSteps;
        this.duration = 0;
        this.offset = 0;

        this.$nextTick(() => {
            const finalOffset = -1 * (stepCount * this.itemHeight);

            this.duration = 2000;

            requestAnimationFrame(() => {
                this.offset = finalOffset;
            });

            this.animationTimeout = setTimeout(() => {
                this.duration = 0;
                this.steps = [this.format(targetValue)];
                this.offset = 0;

                this.currentVal = targetValue;

                this.isSpinning = false;
                this.animationTimeout = null;
            }, 2050);
        });
    },

    get decimalValue() {
        return this.type === 'money' ? this.value / 100 : this.value;
    },

    format(value) {
        return this.type === 'money' ? this.formatMoney(value) : this.formatPercentage(value);
    },

    formatMoney(value) {
        const absValue = Math.abs(value);

        if (absValue >= 1000000) {
            const millions = value / 1000000;
            return '$' + millions.toFixed(3) + 'M';
        } else if (absValue >= 1000) {
            return value.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: 0
            });
        } else {
            return value.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
            });
        }
    },

    formatPercentage(value) {
        return value.toFixed(2) + '%';
    }
});
